const MBB_CONNECTOR_REGISTRY_BASE_URL = process.env.REACT_APP_MBB_CONNECTOR_REGISTRY_BASE_URL;
export const REGISTRY_VEHICLE_DATA_URL = `${MBB_CONNECTOR_REGISTRY_BASE_URL}/status/{vin}`;
export const UNREGISTER_VIN_URL = `${MBB_CONNECTOR_REGISTRY_BASE_URL}/unregister/{vin}`;
export const DELETE_RIO_MFH_DEVICE_URL = `${MBB_CONNECTOR_REGISTRY_BASE_URL}/delete-mfh-device/{vin}`;

const MBB_CONNECTOR_DEVICE_STATE_BASE_URL = process.env.REACT_APP_MBB_CONNECTOR_DEVICE_STATE_BASE_URL;
export const DEVICE_STATE_VEHICLE_DATA_URL = `${MBB_CONNECTOR_DEVICE_STATE_BASE_URL}/{vin}`;
export const MVS_MODE_URL = `${MBB_CONNECTOR_DEVICE_STATE_BASE_URL}/mvs-geo/subscription`;
export const TSS_KAFKA_URL = `${MBB_CONNECTOR_DEVICE_STATE_BASE_URL}/tss-kafka/subscription`;
